module.exports = __webpack_public_path__ + "aquaticminecraftwp194e083e65424d6061703abd1153d12d.png";